module.exports = __webpack_public_path__ + "media/assets/images/flags/ax-2313678988cdcc0ddac27cddbb2c5739.svg";